module.exports = __webpack_public_path__ + "img/back.11c9180e.jpg";